module.exports = __webpack_public_path__ + "img/logo.aa401378.png";